import { forwardRef } from "react"

export default forwardRef(function CodeTextarea(
  { identifier, onChange, numberOfLines, setNumberOfLines, readOnly = false },
  ref
) {
  let timeout = null

  const onChangeHandler = () => {
    setNumberOfLines(ref.current.value.split("\n").length)
    // wait for input change end then convert value and display result
    clearTimeout(timeout)
    if (onChange) timeout = setTimeout(onChange, 400)
  }
  return (
    <div
      style={{ fontFamily: "monospace" }}
      className="d-flex bg-light rounded-2 border-primary mb-2"
    >
      <div
        style={{ minWidth: "4rem", borderRight: "1px solid darkgray" }}
        className="d-flex justify-content-end flex-column h-100"
      >
        {Array(numberOfLines)
          .fill(null)
          .map((_, index) => (
            <span className="text-nowrap text-end pe-2" style={{ color: "darkgray" }} key={index}>
              {index + 1}
            </span>
          ))}
      </div>
      <textarea
        key={identifier}
        onChange={onChangeHandler}
        className="border-0 p-0 ps-3 bg-white text-black outline-none overflow-y-hidden w-100"
        style={{ fontFamily: "monospace" }}
        id={identifier}
        name={identifier}
        readOnly={readOnly}
        ref={ref}
        rows="30"
        cols="50"
      ></textarea>
    </div>
  )
})
